import api from '../lib/api';

export interface RecentBooking {
  id: number;
  booking_reference: string;
  hotel_name: string;
  guest_name: string;
  checkin_date: string;
  checkout_date: string;
  booking_status: string;
  total_amount: number;
  booking_datetime: string;
}

export interface TopCity {
  city: string;
  booking_count: number;
}

export interface HotelPerformance {
  hotel_name: string;
  booking_count: number;
  total_revenue: number;
}

export interface BookingVolume {
  month: string;
  booking_count: number;
  total_revenue: number;
}

export interface RoomWiseInventory {
  hotel_name: string;
  room_type_name: string;
  total_rooms: number;
  booked_rooms: number;
  available_rooms: number;
}

export interface DashboardMetrics {
  total_revenue: number;
  active_hotels: number;
  total_bookings: number;
  confirmed_bookings: number;
  total_rooms: number;
  total_room_plans: number;
  total_rate_slabs: number;
  average_booking_value: number;
  recent_bookings: RecentBooking[];
  top_cities: TopCity[];
  hotel_performance: HotelPerformance[];
  booking_volume: BookingVolume[];
  room_wise_inventory: RoomWiseInventory[];
}

export interface DashboardResponse {
  success: boolean;
  data: DashboardMetrics;
  timestamp: string;
}

class DashboardService {
  async getDashboardMetrics(): Promise<DashboardResponse> {
    try {
      const response = await api.get('/dashboard/metrics');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }
}

export const dashboardService = new DashboardService();
